import { Fragment } from "react";
import { useParams } from "react-router-dom";
import Result from "./Result";
import PoolItemWideLoaderLarge from "./PoolItemWideLoaderLarge";
import { useApi } from "../lib/useApi";
import { programKey } from "../lib/program";
import { poolTypeById } from "../poolTypes";

// Only the Pool Types with Results render an archive; Free2Play and unknown ids don't.
const archivePoolType = (id) => {
  const poolType = poolTypeById(id);
  return poolType?.result ? poolType : undefined;
};

const ArchivedResults = () => {
  const { id, subdate } = useParams();
  const poolType = archivePoolType(id);

  const renderResultType = (item) => (poolType ? <Result poolType={poolType} item={item} /> : null);

  const renderPrettyDate = (subdate) => {
    const month_part = subdate.slice(-3);
    const year_part = subdate.substring(0, 4);
    switch (month_part) {
      case "-01":
        return "January " + year_part;
      case "-02":
        return "February " + year_part;
      case "-03":
        return "March " + year_part;
      case "-04":
        return "April " + year_part;
      case "-05":
        return "May " + year_part;
      case "-06":
        return "June " + year_part;
      case "-07":
        return "July " + year_part;
      case "-08":
        return "August " + year_part;
      case "-09":
        return "September " + year_part;
      case "-10":
        return "October " + year_part;
      case "-11":
        return "November " + year_part;
      case "-12":
        return "December " + year_part;
      default:
        return null;
    }
  };

  const page_name = poolType
    ? (poolType.result.archiveTitle ?? poolType.name) + " Archived Results: " + renderPrettyDate(subdate)
    : "Error " + id;
  const { data } = useApi(`/api/GetArchivedResults/${id}/${subdate}`, {
    select: (json) => {
      const temp = [];
      for (const result of json.value) {
        temp.push(result);
      }
      // temp.reverse(); dont reverse archives
      return { results: temp, page_name };
    },
  });
  const Results = data ? data.results : [];
  const PageName = data ? data.page_name : "";

  return (
    <div className="row second">
      <div className="large-12 columns" style={{ paddingLeft: "0.3em" }}>
        {Results.length > 0 ? (
          <>
            <h1>{PageName}</h1>
            {Results.map((item) => <Fragment key={programKey(item)}>{renderResultType(item)}</Fragment>)}
          </>
        ) : (
          <PoolItemWideLoaderLarge />
        )}
      </div>
    </div>
  );
};

export default ArchivedResults;
